import { Api, ApiLogin } from '../services/api/axios-config';
import { Environment } from '../environment';

// Único arquivo de shared/offline que muda entre PDVSIAC e FrontSIAC — o
// resto da pasta é idêntico nos dois (mesmo banco local, mesma fila, mesma
// sincronização). Aqui ficam só as ligações com o app: as instâncias do
// axios, a URL do servidor e como aplicar um token novo.

export { Api, ApiLogin };

export const URL_BASE = Environment.URL_BASE;

// Operação "Orçamento" — não movimenta estoque, então a venda nessa operação
// não passa pela conferência de estoque antes do envio (ver sincronizacao.ts).
export const ID_OPERACAO_ORCAMENTO: string = Environment.IDORCAMENTO || '';

// No PDV o Authorization fica fixo nos defaults do axios (ver AuthContext),
// então um token renovado precisa ser aplicado neles também.
export const aplicarToken = (token: string) => {
  localStorage.setItem('APP_ACCESS_TOKEN', JSON.stringify(token));
  Api.defaults.headers.authorization = `Bearer ${token}`;
  ApiLogin.defaults.headers.authorization = `Bearer ${token}`;
};
